import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the auth state type
interface AuthState {
  user: any | null;
  isAuthenticated: boolean;
  loading: boolean;
}

// Create the initial state
const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  loading: false,
};

// Create the auth slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

// Export actions
export const { setUser, setLoading, logout } = authSlice.actions;

// Create the store
export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 